import { render, staticRenderFns } from "./copys.vue?vue&type=template&id=e55dbb48&scoped=true&"
import script from "./copys.vue?vue&type=script&lang=js&"
export * from "./copys.vue?vue&type=script&lang=js&"
import style0 from "./copys.vue?vue&type=style&index=0&id=e55dbb48&lang=less&scoped=true&"
import style1 from "./copys.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55dbb48",
  null
  
)

export default component.exports